<script setup>
import { useTheme } from 'vuetify'

const props = defineProps({
  enabled: { type: Boolean, default: false },
})

defineEmits(['show-human-tracking-overlay'])

const theme = useTheme()
</script>

<template>
  <v-chip
    class="px-4"
    prepend-icon="mdi-target-account"
    :append-icon="props.enabled ? 'mdi-check-circle' : undefined"
    variant="elevated"
    :color="props.enabled ? 'primary' : theme.current.value.colors.surface"
    @click="$emit('show-human-tracking-overlay')"
  >
    {{ $t('canvas.settings.overlay.human_tracking.title') }}
  </v-chip>
</template>
